import { useState } from "react";
import { debounce } from "lodash";

import { smallScreen } from "../../constants/screenSizes";
import generateEventPair from "../generateEventPair";

const { dispatcher, responder } = generateEventPair({
  eventName: "useIsMobile:resize"
});

const windowResizeEventListener = debounce(event => {
  dispatcher({ windowWidth: event.target.innerWidth });
}, 20);

// eslint-disable-next-line no-unused-expressions
global?.addEventListener?.("resize", event => windowResizeEventListener(event));

export const useIsMobile = (maxWidth = smallScreen) => {
  const [isMobile, setIsMobile] = useState(global.innerWidth <= maxWidth);

  const setIsMobileEvent = ({ detail: { windowWidth } }) =>
    setIsMobile(windowWidth <= maxWidth);

  responder(setIsMobileEvent);

  return isMobile;
};
